import React from 'react';
import componentMap from '../../../utils/componentMap';
import ArticleFooter from './types/ArticleFooter';
import PluggedinFooter from './types/PluggedinFooter';
import ModernCEO from './types/ModernCEO/index';

const NewsletterWidget = props => {
  // Determine view
  const Component = componentMap(props, {
    modernCeo: ModernCEO,
    articleFooter: ArticleFooter,
    pluggedIn: PluggedinFooter,
    default: ArticleFooter
  });

  return <Component type={Component.displayName} {...props} />;
};

NewsletterWidget.displayName = 'NewsletterWidget';

export default NewsletterWidget;
